import { UNKNOWN } from './resignationPayout'

/** Leave days to at most two places in the reader's language; a missing or unreadable value is UNKNOWN, never zero. */
export function formatLeaveDays(value: number | string | null | undefined, locale: string): string {
  if (value === null || value === undefined || value === '') return UNKNOWN
  const days = Number(value)
  if (!Number.isFinite(days)) return UNKNOWN
  return days.toLocaleString(locale, { maximumFractionDigits: 2 })
}
